module.exports = __webpack_public_path__ + "img/header.234fbc8a.jpg";